import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export default function TrendChart({ data }) {
  return (
    <div className="chart" data-testid="trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <defs>
            <linearGradient id="rainFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#38bdf8" stopOpacity={0.32} />
              <stop offset="100%" stopColor="#38bdf8" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="hour"
            tick={{ fill: "#718178", fontSize: 10 }}
            interval={3}
          />
          <YAxis tick={{ fill: "#718178", fontSize: 10 }} width={28} />
          <Tooltip
            contentStyle={{
              background: "#0f2440",
              border: "1px solid #2a5488",
              color: "#f1f5f9",
              fontSize: 12,
            }}
          />
          <Area
            type="monotone"
            dataKey="rain"
            stroke="#38bdf8"
            fill="url(#rainFill)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="wave"
            stroke="#f97316"
            fill="none"
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
